<template>
  <div>
    <div class="card">
      <div class="card-header" style="height: 3rem" id="headingEvent">
        <div class="d-flex h-100 justify-content-between align-items-center">
          <h5>Steps</h5>
          <ul class="nav nav-tabs" style="padding-top: 0.5rem" role="tablist" v-if="event.event_type_id === 3">
            <li class="nav-item">
              <a class="nav-link active" data-toggle="tab" href="#main" role="tab" @click="changeOrderType(1)">Main</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" data-toggle="tab" href="#postEvent" role="tab"
                @click="changeOrderType(2)">Post-Event</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <div class="tab-content">
              <div class="tab-pane fade show active" id="main" role="tabpanel">
                <div v-if="pre_event_steps.length === 0">
                  <b>Click below to add a new step.</b>
                </div>
                <div v-for="step in pre_event_steps" :key="step.event_step_id">
                  <DropBox class="drop-zone" :id="'drop-zone-' + step.order" @dragenter="handleDragEnter"
                      @dragleave="handleDragLeave" @drop="handleDrop" :style="{ 'z-index': dragging ? 1 : -1, position: 'relative'}" />
                  <div v-if="step.event_step_command_type_id === 3" :id="step.order" class="new-step-btn"
                    href="#" @click="addEventStep">
                    <i class="fa fa-plus" aria-hidden="true"></i><div>&nbsp;Add New Step</div>
                  </div>
                  <DragBox :id="step.event_step_id"
                    @dragstart="$event => handleDragStart($event, step)" @dragend="handleDragEnd">
                    <StepInfo :step="step" :callback="handleStep" />
                  </DragBox>
                </div>
              </div>
              <div class="tab-pane fade" id="postEvent" role="tabpanel">
                <div v-if="post_event_steps.length === 0">
                  <b>Click below to add a new step.</b>
                </div>
                <div v-for="step in post_event_steps" :key="step.event_step_id">
                  <DropBox class="drop-zone" :id="'drop-zone-' + step.order" @dragenter="handleDragEnter"
                      @dragleave="handleDragLeave" @drop="handleDrop" :style="{ 'z-index': dragging ? 1 : -1, position: 'relative'}" />
                  <div v-if="step.event_step_command_type_id === 3" :id="step.order" class="new-step-btn"
                  href="#" @click="addEventStep">
                    <i class="fa fa-plus" aria-hidden="true"></i><div>&nbsp;Add New Step</div>
                  </div>
                  <DragBox :id="step.event_step_id"
                    @dragstart="$event => handleDragStart($event, step)" @dragend="handleDragEnd">
                    <StepInfo :step="step" :callback="handleStep" />
                  </DragBox>
                </div>
              </div>
              <DropBox class="drop-zone" :id="'drop-zone-' + (event_steps_length + 1)" @dragenter="handleDragEnter"
                @dragleave="handleDragLeave" @drop="handleDrop" :style="{ 'z-index': dragging ? 1 : -1, position: 'relative'}" />
              <div class="new-step-btn" id="0" href="#" @click="addEventStep">
                <i class="fa fa-plus" aria-hidden="true"></i><div>&nbsp;Add New Step</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Modal modal_id='eventStepModal' size='lg' @close="resetModal">
      <template v-slot:title>
        {{ modal_title }}
      </template>
      <template v-slot:body>
        <EditEventStep v-if="modal_type === 'EditEventStep'" :event_id="event_id"
          :event_step_id="event_step_id_to_edit" />
        <AddEventStep v-else-if="modal_type === 'AddEventStep'" :event_id="event_id" :event_step_order_type_id="event_step_order_type_id" :event_step_order="event_step_order_to_add" />
      </template>
    </Modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Modal from '../Modal'
import EditEventStep from './EditEventStep'
import AddEventStep from './AddEventStep'
import StepInfo from './StepInfo.vue'
import DropBox from '../DropBox.vue'
import DragBox from '../DragBox.vue'

export default {
  props: {
    event_id: [Number, String],
    event: Object,
    event_steps: Array
  },
  data: function () {
    return {
      event_step_order_type_id: 1,
      modal_type: 'EditEventStep',
      event_step_id_to_edit: 0,
      event_step_order_to_edit: 0,
      event_step_order_to_add: 0,
      dragging: false
    }
  },
  computed: {
    pre_event_steps() {
      return this.event_steps.filter(
        (eventStep) => eventStep.event_step_order_type_id === 1
      )
    },
    post_event_steps() {
      return this.event_steps.filter(
        (eventStep) => eventStep.event_step_order_type_id === 2
      )
    },
    event_steps_length() {
      return this.event_step_order_type_id === 1 ? this.pre_event_steps.length : this.post_event_steps.length
    },
    modal_title() {
      if (this.modal_type === 'EditEventStep') {
        return `Edit Step ${this.event_step_order_to_edit} in ${this.event.name}`
      }
      return `Add Step to ${this.event.name}`
    }
  },
  components: { Modal, EditEventStep, StepInfo, AddEventStep, DropBox, DragBox },
  methods: {
    ...mapActions(['deleteEventStep', 'executeAlert']),
    editEventStep(eventStep) {
      this.modal_type = 'EditEventStep'
      this.event_step_id_to_edit = eventStep.event_step_id
      this.event_step_order_to_edit = eventStep.order
      $('#eventStepModal').modal('show') // eslint-disable-line
    },
    addEventStep(e) {
      this.modal_type = 'AddEventStep'
      this.event_step_order_to_add = Number(e.currentTarget.id)
      $('#eventStepModal').modal('show') // eslint-disable-line
    },
    reorderEventStep(eventStepId, fromOrder, toOrder) {
      let params = {}

      params.event_step_id = eventStepId
      params.event_id = this.event_id
      params.fromOrder = fromOrder
      params.toOrder = toOrder

      this.$store.dispatch('reorderEventStep', params)
    },
    changeOrderType(orderTypeId) {
      this.event_step_order_type_id = orderTypeId
    },
    getDropZones() {
      return document.querySelectorAll('[id^=drop-zone-]')
    },
    handleDragStart(e, step) {
      e.dataTransfer.setData('text/json', JSON.stringify(step))
      this.dragging = true
    },
    handleDragEnd(e) {
      this.getDropZones().forEach(ref => ref.classList.remove('show'))
      this.dragging = false
    },
    handleDragEnter(e) {
      const jsonData = e.dataTransfer.getData('text/json')
      const data = JSON.parse(jsonData)
      const fromOrder = Number(data.order)
      const toOrder = Number(e.target.id.split('-')[2])

      if (toOrder === fromOrder || toOrder === fromOrder + 1) {
        return
      }

      e.preventDefault()
      this.getDropZones().forEach(el => el.classList.remove('show'))
      e.target.classList.add('show')
    },
    handleDragLeave(e) {
      e.target.classList.remove('show')
    },
    handleDrop(e) {
      this.getDropZones().forEach(el => el.classList.remove('show'))
      const jsonData = e.dataTransfer.getData('text/json');
      const data = JSON.parse(jsonData)
      const fromOrder = Number(data.order)
      let toOrder = Number(e.target.id.split('-')[2])

      if (toOrder === fromOrder || toOrder === fromOrder + 1) {
        return
      }

      if (toOrder > fromOrder) {
        toOrder -= 1
      }

      this.reorderEventStep(data.event_step_id, fromOrder, toOrder)
    },
    handleStep(type, step) {
      if (type === 'delete') {
        this.deleteEventStep(step)
      }

      if (type === 'edit') {
        this.editEventStep(step)
      }
    },
    resetModal() {
      this.event_step_order_type_id = 1
      this.event_step_id_to_edit = 0
      this.event_step_order_to_edit = 0
      this.event_step_order_to_add = 0
    }
  }
}
</script>

<style scoped>
.new-step-btn {
  background-color: rgb(245, 245, 245);
  border: 1px solid #ccc;
  padding: 0.25rem;
  margin-top: 0.5rem;
  text-align: center;
}

.new-step-btn > i {
  font-size: 1.5rem;
}

.new-step-btn > div {
  display: inline-block;
  height: 0;
  width: 0;
  overflow: hidden;
  transition-property: width;
  transition-duration: 250ms;
  transition-delay: 100ms;
  transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.new-step-btn:hover {
  background-color: rgb(198, 197, 197);
  cursor: pointer;
}

.new-step-btn:hover > div {
  height: 1.25rem;
  width: 130px;
}

.drop-zone {
  opacity: 0;
  user-select: none;
  height: 0;
  position: relative;
  transition: all 200ms ease;
}

.drop-zone.show {
  opacity: 1;
  position: relative;
  height: 3.5rem;
  border: 3px dotted black;
  margin: 1rem 0;
}

.drop-zone::after {
  content: "";
  user-select: none;
  top: -25px;
  bottom: -25px;
  left: 0;
  right: 0;
  position: absolute;
  margin-bottom: 0.25rem;
}
</style>
